/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationPricingsIndividualHealthGranteesQuery from '../graphql/queries/GetSimulationPricingsIndividualHealthGranteesQuery.js';

const useGetSimulationPricingsIndividualHealthGranteesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationPricingsIndividualHealthGranteesQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationPricingsIndividualHealthGrantees: R.omit(['__typename'], data?.getSimulationPricingsIndividualHealthGrantees_simulation_pricings_individual_health || {})
  };
};

export default useGetSimulationPricingsIndividualHealthGranteesQuery;
